import { actions } from './actions';
import config from './config';
import delays from './delays';
import guards from './guards';
import * as services from './services';

const options = {
  actions,
  guards,
  services,
  delays,
};

export { config, options };
